import { render, staticRenderFns } from "./CrosswordList.vue?vue&type=template&id=4c86801c"
import script from "./CrosswordList.vue?vue&type=script&lang=js"
export * from "./CrosswordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports